import { useCallback, useState } from 'react'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import API from '@api/api'

const getFileNameFromUrl = (url, index) => {
    try {
        const cleanUrl = (url || '').split('?')[0]
        const name = cleanUrl.split('/').pop()
        if (name) return name
    } catch (e) { }
    return `image_${index + 1}.jpg`
}

const useDownloadSelectedImagesZip = () => {
    const [loading, setLoading] = useState(false)
    const [progress, setProgress] = useState(0)
    const [error, setError] = useState('')

    const normalizeDownloadItems = (items = []) => {
        const dedup = new Map()
        ;(items || []).forEach((item) => {
            if (!item) return
            if (typeof item === 'string') {
                const baseTaskId = item.split('_')?.[0] || item
                if (!baseTaskId) return
                dedup.set(`normal_${baseTaskId}`, { taskId: baseTaskId })
                return
            }
            if (typeof item === 'object') {
                const baseTaskId = (item.taskId || '').split('_')?.[0] || item.taskId
                const imageId = item.imageId
                if (!baseTaskId) return
                const key = imageId ? `batch_${baseTaskId}_${imageId}` : `normal_${baseTaskId}`
                dedup.set(key, imageId ? { taskId: baseTaskId, imageId } : { taskId: baseTaskId })
            }
        })
        return [...dedup.values()]
    }

    const downloadSelected = useCallback(async (downloadItems = [], zipName = '已选图.zip') => {
        const validItems = normalizeDownloadItems(downloadItems)
        if (!validItems.length) {
            setError('没有可下载的图片')
            return { successCount: 0, failCount: 0 }
        }

        setLoading(true)
        setProgress(0)
        setError('')

        const zip = new JSZip()
        const zipFolder = zip.folder(zipName.replace(/\.zip$/i, '')) || zip
        const failedItems = []
        let successCount = 0

        try {
            for (let i = 0; i < validItems.length; i += 1) {
                const currentItem = validItems[i]
                try {
                    const res = currentItem?.imageId
                        ? await API.batchCommonDownload({ taskId: currentItem.taskId, imageId: currentItem.imageId })
                        : await API.commonDownload({ taskId: currentItem.taskId })
                    if (res?.code !== 0 || !res?.data) throw new Error(res?.message || '下载地址获取失败')

                    const imageUrl = res.data
                    const response = await fetch(imageUrl)
                    if (!response.ok) throw new Error('图片下载失败')

                    const blob = await response.blob()
                    const fileName = getFileNameFromUrl(imageUrl, i)
                    zipFolder.file(fileName, blob)
                    successCount += 1
                } catch (e) {
                    failedItems.push(currentItem)
                } finally {
                    setProgress(Math.round(((i + 1) / validItems.length) * 100))
                }
            }

            if (!successCount) {
                throw new Error('下载失败，请稍后重试')
            }

            const content = await zip.generateAsync({ type: 'blob' })
            saveAs(content, zipName)
            return { successCount, failCount: failedItems.length, failedItems }
        } catch (err) {
            setError(err?.message || '下载失败')
            return { successCount, failCount: failedItems.length, failedItems }
        } finally {
            setLoading(false)
        }
    }, [])

    return {
        downloadSelected,
        loading,
        progress,
        error,
    }
}

export default useDownloadSelectedImagesZip
